import { VariantAttribute } from "@swo/shared";
import type { PDPSwarovskiProductVariantFrontend } from "./PDP_SingleImageCarousel/state/types";

export function getAttributes(selectedVariant: PDPSwarovskiProductVariantFrontend): Array<VariantAttribute> {
  const {
    attributes: { showcased, unique, filter },
  } = selectedVariant;

  return showcased.length > 0 ? showcased : [...filter, ...(unique || [])];
}
